var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"photo-icon",style:(_vm.wrapperStyle)},[_c('i',{staticClass:"photo-icon__inner",class:("photo-icon__inner--" + _vm.type),style:(_vm.innerStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }